import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-water_meter",
  "use": "icon-water_meter-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-water_meter\"><path d=\"M384 714.656C384 779.456 441.312 832 512 832s128-52.544 128-117.344c0-43.2-42.656-121.408-128-234.656-85.344 113.248-128 191.456-128 234.656z\" p-id=\"4649\" /><path d=\"M864 64H160c-35.296 0-64 28.704-64 64v768c0 35.296 28.704 64 64 64h704c35.296 0 64-28.704 64-64V128c0-35.296-28.704-64-64-64zM256 128h512v224H256V128zM160 896V128h32v288h640V128h32l0.064 768H160z\" p-id=\"4650\" /><path d=\"M328 192h64v96h-64zM488 192h64v96h-64zM648 192h64v96h-64z\" p-id=\"4651\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/water_meter.svg
// module id = RFc3
// module chunks = 252